function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.26 8.2l-.55-.51-1.02 1.1.55.51 1.02-1.1zm2.99 3.8l.51.55.592-.55-.592-.55-.51.55zm-4.01 2.7l-.55.51 1.02 1.1.55-.51-1.02-1.1zm0-5.4l3.5 3.25 1.02-1.1-3.5-3.25-1.02 1.1zm3.5 2.15l-3.5 3.25 1.02 1.1 3.5-3.25-1.02-1.1z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 12.75a.75.75 0 000-1.5v1.5zm-8.25-1.5H10v1.5h.75v-1.5zm8.25 0h-8.25v1.5H19v-1.5zM15.25 5.5H16V4h-.75v1.5zm0 14.5H16v-1.5h-.75V20zm0-16h-8.5v1.5h8.5V4zm-8.5 0A2.75 2.75 0 004 6.75h1.5c0-.69.56-1.25 1.25-1.25V4zM4 6.75v10.5h1.5V6.75H4zm0 10.5A2.75 2.75 0 006.75 20v-1.5c-.69 0-1.25-.56-1.25-1.25H4zM6.75 20h8.5v-1.5h-8.5V20z",
  fill: "currentColor"
});

function SvgLogOutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgLogOutIcon;